<template>
	<div>
		<div class="vx-row pt-5 pb-5" v-if="index > 0">
			<div class="vx-col w-full">
				<hr>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-2/12" v-if="this.product.condition">
				<div class="flex h-full items-center">
					<productcondition :condition="this.product.condition" :cancel-request="cancelRequest" :cancel-accepted="cancelAccepted" />
				</div>
			</div>
			<div class="vx-col" :class="this.product.condition ? 'w-4/12':'w-6/12'">
				<div class="flex h-full items-center">
					{{ this.product.ean }}
					<font-awesome-icon class="fa-icon cursor-pointer ml-2"
									   :icon="['far', 'copy']"
									   style="font-size: 1.0rem"
									   @click="copyEan" />
				</div>
			</div>
			<div class="vx-col w-3/12 text-right text-xl text-bold">
				<div class="flex h-full items-center float-right">
					<vx-tooltip text="Aantal besteld">
						{{ this.product.quantity }} x
					</vx-tooltip>
				</div>
			</div>
			<div class="vx-col w-3/12 pr-5">
				<div class="flex h-full items-center float-right">
					<vx-tooltip text="Verkoopprijs">
						€{{ this.product.unit_price }}
					</vx-tooltip>
				</div>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-6/12">
				<div class="flex h-full items-center">
					{{ this.product.title }}
				</div>
			</div>
			<div class="vx-col w-4/12 items-center">
				<div class="flex h-full items-center">
					<div>
						<vx-tooltip text="Interne referentie">
							<vs-chip v-if="this.product.reference">
								{{ this.product.reference }}
							</vs-chip>
							<vs-chip class="float-none text-sm" v-else>
								-
							</vs-chip>
						</vx-tooltip>
					</div>

					<div>
						<vx-tooltip text="Opslaglocatie">
							<vs-chip v-if="this.product.location">
								{{ this.product.location }}
							</vs-chip>
							<vs-chip class="float-none text-sm" v-else>
								-
							</vs-chip>
						</vx-tooltip>
					</div>

					<div>
						<vx-tooltip text="Verpakking">
							<vs-chip v-if="this.product.package_id">
								Onbekend
							</vs-chip>
							<vs-chip class="float-none text-sm" v-else>
								-
							</vs-chip>
						</vx-tooltip>
					</div>
				</div>
			</div>
			<div class="vs-col w-2/12 pr-5 h-full items-center text-right">
				<div class="flex h-full items-center float-right">
					<vx-tooltip text="Bemiddelingsbijdrage">
						-{{ this.product.unit_commission }}
					</vx-tooltip>
				</div>
			</div>
		</div>
		<div class="vx-row mt-5" v-if="order.order.type === 1">
			<div class="vx-col w-2/12">
				<div>
					<h6>Verloopdatum product</h6>
					<p>{{ this.product.expiry_date }}</p>
				</div>
			</div>

			<div class="vx-col w-2/12">
				<div>
					<h6>Uiterste leverdatum product</h6>
					<p>{{ this.product.latest_delivery_date }}</p>
				</div>
			</div>

			<div class="vx-col w-4/12">
				<div v-if="this.product.transport_status === 3">
					<div class="vx-row">
						<div class="vx-col w-4/12">
							<div>
								<h6>Verzendstatus</h6>
								<p>Verzonden</p>
							</div>
						</div>
						<div class="vx-col w-4/12">
							<div>
								<h6>Vervoerder</h6>
								<p>{{ this.product.transport_code }}</p>
							</div>
						</div>
						<div class="vx-col w-4/12">
							<div>
								<h6>T&T nummer</h6>
								<p>{{ this.product.transport_track_and_trace }}</p>
							</div>
						</div>
					</div>
				</div>

				<div v-else>
					<div>
						<h6>Verzendstatus</h6>
						<p>Openstaand</p>
					</div>
				</div>
			</div>

			<div class="vx-col w-2/12">
				<div>
					<h6>Stuks gewicht</h6>
					<p>Onbekend</p>
				</div>
			</div>

			<div class="vx-col w-2/12">
				<div>
					<h6>Totaal gewicht</h6>
					<p>Onbekend</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Productcondition from './productcondition';

export default {
	components: {Productcondition},
	props: {
		product: {
			type: Object,
			required: true,
		},
		order: {
			type: Object,
			required: true,
		},
		index: null
	},
	data() {
		return {
			cancelRequest: false,
			cancelAccepted: false,
		}
	},
	watch: {
		product: {
			// the callback will be called immediately after the start of the observation
			immediate: true,
			handler(product) {
				if (product.cancellation_request) {
					this.cancelRequest = true;
				}
				if (product.cancellation_request_status === 3) {
					this.cancelAccepted = true;
				}
			}
		}
	},
	methods: {
		copyEan() {
			this.$copyText(this.product.ean).then(result => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Deze ean code is succesvol naar je klembord gekopieerd!',
					color: 'success',
				});
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het kopiëren is mislukt!',
					color: 'danger',
				});
			});
		},
	}
}
</script>

<style lang="scss">
.vx-card.is-selected {
	background-color: rgba(var(--vs-primary), 0.05);
	-webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
	box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}
</style>
